export default __webpack_public_path__ + "static/media/red-ball.8319aca3.svg";